import { call, put, takeLatest } from 'redux-saga/effects'
import { defineTypes } from '../helpers'
import { reduxFetch } from '../http/reduxFetch'
import KegSizeEndpoint from '../persistence/KegSizeEndpoint'
import InventoryEndpoint from '../persistence/InventoryEndpoint'

const kegSizeOptionsTypes = { ...defineTypes('KEG_SIZE_OPTIONS') }

export const initialState = {
  keg_size_options_0: []
}
export const actions = {
  requestKegSizes (kegNumber, company_id) {
    return { type: kegSizeOptionsTypes.REQUEST, keg_number: kegNumber, company_id: company_id }
  }
}
export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case kegSizeOptionsTypes.REQUEST:
      return { ...state, started: true, loading: true }
    case kegSizeOptionsTypes.FAILURE:
      return { ...state, loading: false }
    case kegSizeOptionsTypes.SUCCESS:
      return { ...state, [`keg_size_options_${action.keg_number}`]: action.data, loading: false, started: false }
    default:
      return state
  }
}

export const selectors = {
  keg_size_options: (store, keg_number) => store.keg_size_options[`keg_size_options_${keg_number}`],
  selected_beer: (store) => {
    return store.reservation.beer_option
  }
}

export function * kegSizeOptionsSaga (action) {
  try {
    const keg_size_options = yield call(reduxFetch, KegSizeEndpoint.index(action.product['value'], action.company_id))
    yield put({ type: kegSizeOptionsTypes.SUCCESS, data: keg_size_options['data'], keg_number: action.keg_number })
  } catch (error) {
    yield put({ type: kegSizeOptionsTypes.FAILURE, error})
  }
}

export function * selectKegSizeSaga (action) {
  try {
    let form = {}
    if (action.keg_size_id['value']['type'] === 'keg_size') {
      return null
    }
    form['id'] = action.keg_size_id['value']['id']
    form['status'] = 'selected'

    const inventory_update = yield call(reduxFetch, InventoryEndpoint.update(form))

    if ( inventory_update['data'] ) {

      yield put({ type: kegSizeOptionsTypes.SUCCESS, data: inventory_update['data'] })
    } else {
      yield put({ type: kegSizeOptionsTypes.FAILURE, error: inventory_update['errors'] })
    }
  } catch (error) {
    yield put({ type: kegSizeOptionsTypes.FAILURE, error})
  }
}

export function * rootSaga () {
  yield takeLatest('PRODUCT_SELECT', kegSizeOptionsSaga)
  yield takeLatest('KEG_SIZE_SELECT', selectKegSizeSaga)
}



// WEBPACK FOOTER //
// ./src/sagas/keg_size_options.js